module.exports = __webpack_public_path__ + "static/media/before.dc335ff3.png";